import {createAction} from '@reduxjs/toolkit'

/** 모바일 영역 > 후불결제 유도 배너 렌더링 여부 제어 */
export const updateShouldMobileAreaPopupBannerRender = createAction<boolean>(
    'banner/updateShouldMobileAreaPopupBannerRender',
)
